import { render, staticRenderFns } from "./SignUp2.vue?vue&type=template&id=613010ec&scoped=true&"
import script from "./SignUp2.vue?vue&type=script&lang=js&"
export * from "./SignUp2.vue?vue&type=script&lang=js&"
import style0 from "./SignUp2.vue?vue&type=style&index=0&id=613010ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613010ec",
  null
  
)

component.options.__file = "SignUp2.vue"
export default component.exports